import { CATEGORY_STATUS, type CategoryStatus } from "@app/types/categories";

export type ExtraSelectedCategoryVariant = "active" | "inactive" | "deleted";

export interface ExtraSelectedCategory {
    categoryId: string;
    label: string;
    variant: ExtraSelectedCategoryVariant;
}

type ResolvedCategory = { categoryName: string; status: CategoryStatus };

// Resolves selected category ids that have no pill in the active list (deactivated, deleted, or unknown).
export function resolveExtraSelectedCategories(
    selectedIds: string[],
    selectableIds: Set<string>,
    categoryMap: Map<string, ResolvedCategory>,
): ExtraSelectedCategory[] {
    return selectedIds
        .filter((id) => !selectableIds.has(id))
        .map((id) => {
            const resolved = categoryMap.get(id);
            if (!resolved) return { categoryId: id, label: "Unknown category", variant: "deleted" };
            if (resolved.status === CATEGORY_STATUS.Deleted) return { categoryId: id, label: `${resolved.categoryName} (deleted)`, variant: "deleted" };
            if (resolved.status !== CATEGORY_STATUS.Active) return { categoryId: id, label: `${resolved.categoryName} (inactive)`, variant: "inactive" };
            return { categoryId: id, label: resolved.categoryName, variant: "active" };
        });
}
